module.exports = __webpack_public_path__ + "img/2025-07-21b_2.2c7be593.jpg";